import { Field } from '../../../libs/gs-component-form';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { Caption } from '@xo-union/tk-ui-typography';
import { Field as FormikField } from 'formik';
import React from 'react';

import { Guest } from '.';
import styles from './editGuestItem.scss';

interface Props {
  guest: Guest;
  index: number;
}

const EditGuestItem: React.FC<Props> = ({ guest, index }) => {
  return (
    <div className={styles.container} key={index}>
      <FormRow>
        <FormColumn xs="12" md>
          <FormikField label="First Name" name={`guests.${index}.firstName`} component={Field} />
        </FormColumn>
        <FormColumn xs="12" md>
          <FormikField label="Last Name" name={`guests.${index}.lastName`} component={Field} />
        </FormColumn>
      </FormRow>
      <Caption className={styles.email}>Email address</Caption>
      <span>{guest.email}</span>
    </div>
  );
};

export default EditGuestItem;
